var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{staticClass:"haha",attrs:{"index":_vm.menu.menuId + ''},on:{"click":function($event){return _vm.gotoRouteHandle(_vm.menu)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.menu.key)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }